// import { DayDisplayDirective } from './../day-display.directive';
import { Signs1InMonthDisplayComponent } from './../signs1-in-month-display/signs1-in-month-display.component';
import { TimeService } from './../time.service';
import { HttpService } from './../http.service';
import { ModalService } from './../_modal';
import { Component, OnInit, ViewChild, ComponentFactoryResolver  } from '@angular/core';
import * as Converters from '../converters/id2ArrayConverters';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router'; 
import { DayModalDataService } from '../day-modal-data.service';

// import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-calendar-container',
  templateUrl: './calendar-container.component.html',
  styleUrls: ['./calendar-container.component.css'],
})
export class CalendarContainerComponent implements OnInit {

  // private cookieVale!: string;

  //Display controller settings for Sign Display components
  // signDisplayMode: string[] = ['show1', 'show2', 'showToday', show1prev, show1post]
  public signDisplayMode: string | null = 'showToday';

  // queryParam: any | undefined =  this.actRoute.snapshot.params['month'];
  queryParam: any | undefined;

  // this.queryParam = {
  //   month : this.actRoute.snapshot.params['month']
  // }


  //Active Sign ID. Default is set to 1.
  activeIndexId: number = 0; //DISPLAYED- MONTH Index number will compute & geneate calendar days & zodiac signs
  currentIndexId: any = 11; //TODAYS- INDEX ID of Zodiac Sign Index ID to be assigned to current-dayComponent  

  monthIndexId: number = 0;
  monthArrayId: number = 0;

  //Display Control Variable for Child Components
  showStartSign: boolean = true;
  currentIsPreOrPost: string = '';
  todaysNumberIs: number = 0; //Todays current date (gets set during the intit phase) 
  todaysMonthArrayIndexIs: number = 0; //Todays current Month (gets set during the intit phase) 
  currentMonthIsActive: boolean = true; //Used by day componenet to render todaySun

  todaysMonthPrevSignID: number = 0;
  todaysMonthPostSignID: number = 0;
  monthMenuData: any; 
  cuspDayDisplay: boolean = false;

  //Pre & Post Days in Month
  preDays: number[] = []; 
  postDays: number[] = []; 
  currentDays: number[] = [];

  //Moon Dates
  fullMoon: number | undefined; 
  fullMoon2: number | undefined; 
  newMoon: number | undefined; 
  newMoon2: number | undefined; 
  firstqmoon: number | undefined; 
  firstqmoon2: number | undefined; 
  lastqmoon: number | undefined; 
  lastqmoon2: number | undefined; 
  fullMoonName: any | undefined;
  fullMoonName2: any | undefined;

  //SignData
  preSignIcon: string = '';
  postSignIcon: string = '';
  transferDate: number = 0;
  preSignName: string = '';
  postSignName: string = '';
  currentMontName: string = '';

  preElement: string = "";
  preQuality: string = "";
  preGlyph: string = "";
  preHouse: string = "";
  prePlanet: string = "";
  preSignColor: any = []; 

  preElementName: string = "";
  preQualityName: string = "";
  preHouseName: string = "";
  prePlanetName: string = "";
  preShortDescription: string = '';

  postElement: string = "";
  postQuality: string = "";
  postGlyph: string = "";
  postHouse: string = "";
  postPlanet: string = "";
  postSignColor: string = ""; 


  postElementName: string = "";
  postQualityName: string = "";
  postHouseName: string = "";
  postPlanetName: string = "";
  postShortDescription: string = '';

  currentSignName: string = "";
  currentIcon: string = "";
  currentElement: string = "";
  currentQuality: string = "";
  currentGlyph: string = "";
  currentHouse: string = "";
  currentPlanet: string = "";
  currentShortDescription: string ="";
  currentColor: string ="";

  preSignProfile: any[] = [];
  postSignProfile: any[] = [];
  allSignProfiles: any[]=[];

  //display toggle setting
  defaultToggles: boolean = false;
  showNavModal: boolean = false;
  showSignsInMenu: boolean = false;
  showMonthsInMenu: boolean = false;


  //modal values
  lazy: any[] = [];
  lazycollection: any[] = [];
  allData: any[] = [];

  dataInfo: string = 'stuff here';
  //Injectable Config for http/get data calls. 
  //1. requires constructor to inject service
  //2. object to hold received data
  //3. ngOnInit to make the calland fetch data using the service when the app is first initialized
  zodiacData: any ;

  // @ViewChild(Signs1InMonthDisplayComponent) AlterSigns1Display!: Signs1InMonthDisplayComponent;


  //Inject services and directives 
  constructor(private _http: HttpService, private _time: TimeService, private _componentFactoryResolver: ComponentFactoryResolver, private actRoute: ActivatedRoute, private router: Router, private dayModalDataService: DayModalDataService,
    private modalService: ModalService) {

   }

  ngOnInit() {

    // this._http.getZodaicData()


    // this.cookieService.set('cookieName', 'Our cookie value');
    // this.cookieVale = this.cookieService.get('cookieName');
    // console.log('cookie', this.cookieVale);

    
    // console.log('init calContainer -get calendar data ')
    this._http.getZodaicData().subscribe(data =>{
      this.allData.push(data);
      this.allSignProfiles.push( this.allData[0].signs);
      // console.log('allData is', this.allData[0]);
      // console.log('allSignProfiles is', this.allSignProfiles[0]);
      // console.log('allData is', this.allData[0].months[this.activeIndexId].prevDays);
      
      //Collect Data for selection boxes
      this.monthMenuData = this.allData[0].months;
      // console.log('month check', this.monthMenuData)

      //Initialize with Todays Actual Date
      this.activeIndexId = this._time.getcurrentMonthIndexId(); //Month Today as Active Display Setting
      
      //Get current transfer date of the current month
      let currentTransferDate = this.allData[0].months[this.activeIndexId].transferDate;
      //Get Todays Month
      this.todaysMonthArrayIndexIs = this._time.getcurrentMonthIndexId();
      //Get Todays date
      this.todaysNumberIs = this._time.getTodaysNumber();
      // console.log('check today num', this.todaysNumberIs)
      //Resolve if today is the start or end sign
      let TodaysSunSignID = this.todaysNumberIs <= currentTransferDate ?  this.allData[0].months[this.activeIndexId].startSignId : this.allData[0].months[this.activeIndexId].endSignId; //Zodiac Default Setting
      //Convert the Sun Signs ID to Index ID
      let TodaysSunSignArrayId = Converters.signId2ArrayId(TodaysSunSignID);

      //set the months active prev and post sign

 
      this.todaysMonthPrevSignID = this.allData[0].months[this.todaysMonthArrayIndexIs].startSignId;
      this.todaysMonthPostSignID = this.allData[0].months[this.todaysMonthArrayIndexIs].endSignId;
      // console.log(this.todaysMonthPrevSignID, this.todaysMonthPostSignID)

      //assign the today sign to the current sign for the TodayDisplay Component
      this.currentIndexId = TodaysSunSignArrayId;
      this.currentIsPreOrPost = this.todaysNumberIs <= currentTransferDate ? 'show1prev' : 'show1post';
      // console.log('check todays sign', TodaysSunSignArrayId);
      
      //check if today is a cusp transition day or a single sign for the today component. 
      currentTransferDate - 3 <= this.todaysNumberIs && this.todaysNumberIs <= currentTransferDate + 3 ? this.cuspDayDisplay = true: null 



      //check if requested month by URL
      this.queryParam = { month : this.actRoute.snapshot.params['month'] }
      // console.log('init param val check', this.queryParam.hasOwnProperty('month'))
     
      // console.log('init param is', this.queryParam.month)
      if(this.queryParam.month){
        // console.log('its true and runs')
        let chosenMonth: any = Converters.monthName2ArrayIndex(this.queryParam.month)
        //convert month name to month or sign name index id 
        // console.log('init param chosenMonth is', chosenMonth)
        chosenMonth !== "invalid month name" ? (this.activeIndexId = chosenMonth, this.signDisplayMode = 'show2') : null;
        //check if the displayed month gets a today sun.

        // this.currentMonthIsActive=false; //today sun setting
        let monthIndexIdIs = this._time.getcurrentMonthIndexId(); //todays actual index number
        chosenMonth === monthIndexIdIs ?  this.currentMonthIsActive = true :  this.currentMonthIsActive = false;
        this.currentMonthIsActive ? this.signDisplayMode = 'showToday' : (null);
        this.cuspDayDisplay && this.currentMonthIsActive ? this.signDisplayMode = 'cusp' : (null);
      }

      // this.activeIndexId = 2;
      // console.log('time service?', this._time.getcurrentMonthIndexId())
      this.GenerateNewMonth()
    })




  }


  //Navigation Controls
  nextSignId () {
    this.activeIndexId === 11 ? this.activeIndexId = 0 : this.activeIndexId +=1;
    this.signDisplayMode === 'showToday' ? (this.signDisplayMode = 'show2', this.cuspDayDisplay = false) : null;
    this.todaysMonthArrayIndexIs === this.activeIndexId ? this.currentMonthIsActive = true : this.currentMonthIsActive = false;

    this.GenerateNewMonth()
  };
  prevSignId () {
    this.activeIndexId === 0 ? this.activeIndexId = 11 : this.activeIndexId -=1;
    this.signDisplayMode === 'showToday' ? (this.signDisplayMode = 'show2', this.cuspDayDisplay = false) : null;
    this.todaysMonthArrayIndexIs === this.activeIndexId ? this.currentMonthIsActive = true : this.currentMonthIsActive = false;

    this.GenerateNewMonth()
  };
  
  //Dropdown Controlls
  jumpTo(selectedOption: any){
    //reset sign display if any are active
    

    //convert the selectedOption to the activeIndexId and generate the calendar 
    //check key name to know how to translate the ID to Index Id.
    if(selectedOption.hasOwnProperty('signId')){
      //convert ID to Index

      // console.log('selectedOption.signId', selectedOption.signId)
      let signIdArrayId: any = Converters.signId2MonthArrayId(selectedOption.signId);
      // console.log('signIdArrayId', signIdArrayId)
      //check if the selected ID is prev or post in active (check for today sun in calendar display)
      // console.log('submitted sign, prev, post', selectedOption.signId), this.todaysMonthPrevSignID, this.todaysMonthPostSignID;
      // console.log('monthindexId', this.todaysMonthArrayIndexIs )
      //selectedOption.signId == this.todaysMonthPrevSignID || selectedOption.signId == this.todaysMonthPostSignID ? (this.setDisplay('showToday'), this.currentMonthIsActive = true) : (this.setDisplay('show2'), this.currentMonthIsActive = false);
      selectedOption.signId == this.todaysMonthPostSignID ? this.currentMonthIsActive = true : this.currentMonthIsActive = false;
      
      this.activeIndexId = signIdArrayId;
      this.signDisplayMode = 'show1';
      this.showStartSign = false;
      this.GenerateNewMonth();

      // console.log('selectedOption selectedOption.monthId', selectedOption.signId);
      // console.log('selectedOption signArrayId', signIdArrayId);

    }

    if(selectedOption.hasOwnProperty('monthId')){
      //convert ID to Index
      let monthrrayId: any = Converters.monthId2ArrayId(selectedOption.monthId);
      this.activeIndexId = monthrrayId;

      //check if the selected ID is todays active (check for today sun)
      monthrrayId === this.todaysMonthArrayIndexIs ? (this.setDisplay('showToday'), this.currentMonthIsActive = true) : (this.setDisplay('show2'), this.currentMonthIsActive = false);

      //this.signDisplayMode === 'showToday' ? this.signDisplayMode = 'show2' : null;
      this.GenerateNewMonth();

    }
    // console.log('selectedOption', selectedOption.hasOwnProperty('monthId'));

  };
  //Sends the child component request for new month to the proper function
  monthSelector(route: string){
    route === 'prev' ? this.prevSignId() : this.nextSignId();
  };

  //sets the current local month to the display when clicked from child components
  setCurrntMonth(monthArrayIdInfo: number){
    this.activeIndexId = this._time.getcurrentMonthIndexId();
  }



  GenerateNewMonth(){

    let prevDaysCollection: any[] =[];
    let postDaysCollection: any[] =[];
    let currentDaysCollection: any[] =[];

    let presignId: any = Converters.signId2ArrayId(this.allData[0].months[this.activeIndexId].startSignId);
    let postsignId: any = Converters.signId2ArrayId(this.allData[0].months[this.activeIndexId].endSignId);

    //Programatically load components
    // const componentFactory = this._componentFactoryResolver.resolveComponentFactory(TesterComponent);
    // this.day.viewContainerRef.clear(); //clear existing data
    // this.day.viewContainerRef.createComponent(componentFactory);
    
    // this.day.viewContainerRef.clear(); //clear existing data


          //Generate Prev Days in month 
          for (var i = 0; i < this.allData[0].months[this.activeIndexId].prevDays; ++i){
            prevDaysCollection.push(this.allData[0].months[this.activeIndexId].startSignId);
          }
    
          //Generate Post Days in month
          for (var i = 0; i < this.allData[0].months[this.activeIndexId].postDays; ++i){
            postDaysCollection.push(this.allData[0].months[this.activeIndexId].endSignId);
          }
          //Generate current Days in month
          for (var i = 0; i < this.allData[0].months[this.activeIndexId].daysInMonth; ++i){
            currentDaysCollection.push(1+i);
            }


          //Set Sign Data & Icons for Calendar
          this.transferDate = this.allData[0].months[this.activeIndexId].transferDate; 
          this.preSignIcon = this.allData[0].months[this.activeIndexId].startSignIconDisplayCharacter;
          this.postSignIcon = this.allData[0].months[this.activeIndexId].endSignIconDisplayCharacter;
          this.preSignName = this.allData[0].months[this.activeIndexId].startSign;
          this.postSignName = this.allData[0].months[this.activeIndexId].endSign;
          this.currentMontName = this.allData[0].months[this.activeIndexId].monthName;

          //Set current, Pre & Post Sign data for child components
          // this.preSignProfile = this.allSignProfiles[0][presignId];
          // this.postSignProfile = this.allSignProfiles[0][postsignId];

          //Current Data - TODAYS LIVE DATA - 
          this.currentIcon = this.allData[0].signs[this.currentIndexId].iconDisplayCharacter
          this.currentSignName = this.allData[0].signs[this.currentIndexId].signName
          this.currentElement = this.allData[0].signs[this.currentIndexId].elementDisplayCharacter;
          this.currentQuality = this.allData[0].signs[this.currentIndexId].qualityDisplayCharacter;
          this.currentGlyph = this.allData[0].signs[this.currentIndexId].glyphDisplayCharacter;
          this.currentHouse = this.allData[0].signs[this.currentIndexId].houseDisplayCharacter;
          this.currentPlanet = this.allData[0].signs[this.currentIndexId].planetDisplayCharacter;
          this.currentShortDescription = this.allData[0].signs[this.currentIndexId].shortDescription;
          this.currentColor = this.allData[0].signs[this.currentIndexId].mainColor;

          //Moon Phases & Dates
          this.fullMoon = this.allData[0].months[this.activeIndexId].fullMoonDate;
          this.fullMoon2 = this.allData[0].months[this.activeIndexId].fullMoonDate2;
          this.newMoon = this.allData[0].months[this.activeIndexId].newMoonDate;
          this.newMoon2 = this.allData[0].months[this.activeIndexId].newMoonDate2;
          this.firstqmoon = this.allData[0].months[this.activeIndexId].firstqmoon;
          this.firstqmoon2 = this.allData[0].months[this.activeIndexId].firstqmoon2;
          this.lastqmoon = this.allData[0].months[this.activeIndexId].lastqmoon;
          this.lastqmoon2 = this.allData[0].months[this.activeIndexId].lastqmoon2;
          this.fullMoonName = this.allData[0].months[this.activeIndexId].fullMoonName;
          this.fullMoonName2 = this.allData[0].months[this.activeIndexId].fullMoonName2;

          //Pre Data
          this.preElement = this.allData[0].signs[presignId].elementDisplayCharacter;
          this.preQuality = this.allData[0].signs[presignId].qualityDisplayCharacter;
          this.preGlyph = this.allData[0].signs[presignId].glyphDisplayCharacter;
          this.preHouse = this.allData[0].signs[presignId].houseDisplayCharacter;
          this.prePlanet = this.allData[0].signs[presignId].planetDisplayCharacter;
          this.preElementName = this.allData[0].signs[presignId].family;
          this.preQualityName = this.allData[0].signs[presignId].quality;
          this.preHouseName = this.allData[0].signs[presignId].house;
          this.prePlanetName = this.allData[0].signs[presignId].planet;
          this.preShortDescription = this.allData[0].signs[presignId].shortDescription;
          this.preSignColor = this.allData[0].signs[presignId].mainColor;


          //Post Data
          this.postElement = this.allData[0].signs[postsignId].elementDisplayCharacter;
          this.postQuality = this.allData[0].signs[postsignId].qualityDisplayCharacter;
          this.postGlyph = this.allData[0].signs[postsignId].glyphDisplayCharacter;
          this.postHouse = this.allData[0].signs[postsignId].houseDisplayCharacter;
          this.postPlanet = this.allData[0].signs[postsignId].planetDisplayCharacter;
          this.postElementName = this.allData[0].signs[postsignId].family;
          this.postQualityName = this.allData[0].signs[postsignId].quality;
          this.postHouseName = this.allData[0].signs[postsignId].house;
          this.postPlanetName = this.allData[0].signs[postsignId].planet;
          this.postShortDescription = this.allData[0].signs[postsignId].shortDescription;
          this.postSignColor = this.allData[0].signs[postsignId].mainColor;

          //send all compiled data to appropriate child components. array index value is used by template
          this.preDays = Object.assign(prevDaysCollection);
          this.postDays = Object.assign(postDaysCollection);
          this.currentDays = Object.assign(currentDaysCollection);
          this.lazycollection = Object.assign(this.lazy)
          // console.log('check profiles', this.preSignProfile, this.postSignProfile)
          // console.log('check arrays', prevDaysCollection, currentDaysCollection, postDaysCollection)


          //Set Modal Data
          this.fullMoon = this.allData[0].months[this.activeIndexId].fullMoonDate;
          this.fullMoon2 = this.allData[0].months[this.activeIndexId].fullMoonDate2;
          this.newMoon = this.allData[0].months[this.activeIndexId].newMoonDate;
          this.newMoon2 = this.allData[0].months[this.activeIndexId].newMoonDate2;
          this.firstqmoon = this.allData[0].months[this.activeIndexId].firstqmoon;
          this.firstqmoon2 = this.allData[0].months[this.activeIndexId].firstqmoon2;
          this.lastqmoon = this.allData[0].months[this.activeIndexId].lastqmoon;
          this.lastqmoon2 = this.allData[0].months[this.activeIndexId].lastqmoon2;
          this.fullMoonName = this.allData[0].months[this.activeIndexId].fullMoonName;
          this.fullMoonName2 = this.allData[0].months[this.activeIndexId].fullMoonName2;


          //change url route
          this.router.navigateByUrl('2021/' + this.currentMontName); //normal url
          // this.currentMonthIsActive ? this.signDisplayMode = 'showToday' : (null);


  };

  //Sets the Visibility of the display container in the template & generates Today
  setDisplay(setting: string){
    // console.log('check display setting', setting);
    //'show1', 'show2', 'showToday'

    setting === 'showToday' ? this.generateToday() : null;
    setting === 'showToday' ? this.currentMonthIsActive = true : null;
    this.cuspDayDisplay === true && setting === 'showToday' ? setting = 'cusp': null;

    
    if (setting === 'show1prev'){
      this.showStartSign = true;
      setting = 'show1';
    }

    if (setting === 'show1post'){
      this.showStartSign = false;
      setting = "show1";
    }

    this.signDisplayMode = setting;
    // console.log('check display setting 2', setting);
  };
  generateToday(){
    // console.log('genToday hit');
    this.activeIndexId = this._time.getcurrentMonthIndexId();
    //set the current sign name 
    this.GenerateNewMonth();
  }


 //reset all active toggles in the top menu
 resetToggles(event: any){
  //  console.log('reset toggle event', event.source);
   let toggle = event.source;
 }





 //Modal Functions
 setModalData(modalInfo: any){
  //  console.log('check date in grandpa', modalInfo, this.currentMontName) ;

       //send selected date to modal
       this.dayModalDataService.changeModalData(modalInfo, this.currentMontName);

 }

 gotoSignProfile(chosenSign: string){
  // this.router.navigateByUrl('http://localhost:8080/zodiacsigns/' + chosenSign) //normal url
  // this.router.navigate(['2021', '7']); //parameter based url
  // this.router.navigate([http://localhost:8080/zodiacsigns/', 'chosenSign']); //parameter based url


  // let newpage = 'http://localhost:8080/zodiacsigns/' + chosenSign;
  let newpage = environment.bosSignProfiles + '/' + chosenSign;

  
  // let newpage = bosSignProfiles + chosenSign;
  // bosSignProfiles
  // alert(newpage)
  // window.location.href = 'http://localhost:8080/zodiacsigns/' + chosenSign;
  window.location.href = newpage;
  console.log('go')
 }

 gotoZodiacProfiles(){
   window.location.href = environment.bosSignProfiles;
  console.log('go to zodiac profiles', environment.bosSignProfiles)

 }



 //modal Nav controls
 openNavModal() {
  this.showNavModal = true;
  }

closeNavModal() {
  this.showNavModal = false;
    
  }
  toggleShowMonthsMenu(){
    this.showMonthsInMenu = this.showMonthsInMenu === true ? false: true;
  }
  toggleShowSignsMenu(){
    this.showSignsInMenu = this.showSignsInMenu === true ? false : true;
  }
  

}
